(function () {

    "use strict";

    var userkey = "utoken";

    function currentUser(sessionStorage, $log, $rootScope) {

        var vm = this;

        vm.profile = initialize();
        vm.setAuthInfo = setAuthInfo;
        vm.clear = clear;

        function initialize() {
            var user = {
                token: "",
                userName: "",
                tenant: "",
                rol: "",
                get loggedIn() {
                    return this.token !== "";
                }
            };

            $log.debug("Initializing currentUser.");

            var localUser = sessionStorage.get(userkey);

            if (localUser) {
                $log.debug("- Loading saved currentUser info.");
                user.userName = localUser.userName;
                user.token = localUser.token;
                user.tenant = localUser.tenant;
                user.rol = localUser.rol;

            } else {
                $log.debug("- Not saved currentUser info.");
            }
            return user;
        }

        function setAuthInfo(userName, token, tenant, rol) {
            $log.debug("Setting new currentUser info");
            $rootScope.user = undefined;
            vm.profile.userName = userName;
            vm.profile.token = token;
            vm.profile.tenant = tenant;
            vm.profile.rol = rol;
            sessionStorage.add(userkey, vm.profile);
        }

        function clear() {
            $log.debug("Clearing currentUser info");
            $rootScope.user = undefined;
            sessionStorage.remove(userkey);
            vm.profile.userName = "";
            vm.profile.token = "";
            vm.profile.tenant = "";
        }
    }

    currentUser.$inject = ["sphForms.storage", "$log", "$rootScope"];

    angular.module("sphForms.auth")
        .service("sphForms.currentUser", currentUser);

})();
